// import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "animate.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import * as serviceWorker from "./serviceWorker";
import "./assets/js/ready";

import api from "./api";
React.api = api;
// 防抖
// React.debounce = function(func, wait) {
//   let timeout;
//   return function() {
//     let context = this;
//     let args = arguments;
//     if (timeout) clearTimeout(timeout);
//     let callNow = !timeout;
//     timeout = setTimeout(() => {
//       timeout = null;
//     }, wait);
//     if (callNow) func.apply(context, args);
//   };
// };
// 节流
// React.throttle = function(func, wait) {
//   let previous = Date.now();
//   return function() {
//     let now = Date.now();
//     let context = this;
//     let args = arguments;
//     if (now - previous > wait) {
//       console.log("节流");
//       func.apply(context, args);
//       previous = now;
//     }
//   };
// };
ReactDOM.render(
  <Provider store={store}>
    <App />
    <audio
      preload
      src="http://publics3.gileadchina.cn/video/hiv1912/audio_bg.mp3"
      id="bgAudio"
      loop
    ></audio>
    <audio
      preload
      src="http://publics3.gileadchina.cn/video/hiv1912/audio_btn.mp3"
      id="btnAudio"
    ></audio>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
